import React, { Component } from 'react';
import StepContainer from 'components/StepContainer';
import StepButtons from 'components/StepButtons';
import styled from 'styled-components';
import { goBack } from 'modules/history';

const ExplanacionConceptsBox = styled.div`
  margin-left: 50px;
  margin-right: 30px;
  @media (max-width: 1000px) {
    margin-left: 15%;
    margin-right: 15%;
  }
  @media (max-width: 500px) {
    margin-left: 15px;
    margin-right: 15px;
  }
`;

const CardTitle = styled.p`
  color: #38b6ff;
  font-size: 25px;
  text-align: center;
  margin-top: 55px;
`;

export const ContentTitle = styled.p`
  font-family: 'Josefin Sans', sans-serif;
  font-size: 28px;
  text-align: center;
  margin-top: 60px;
  margin-left: 70px;
  margin-right: 70px;
  color: #808080;
`;

export const ContentBody = styled.p`
  font-family: 'Josefin Sans', sans-serif;
  font-size: 14px;
  line-height: 1.47;
  color: #999999;
  text-align: justify;
  height: 100%;
  padding-right: 15px;
  max-height: ${props => props.maxHeight}px;
  overflow: auto;
`;

class ExplanacionConceptsView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { changeStep, state, stepFields } = this.props;
    const { localStep } = state;
    return (
      <StepContainer closeIcon width={'600px'} closeAction={() => goBack()}>
        <ExplanacionConceptsBox>
          <div style={{ marginBottom: '50px' }}>
            <CardTitle>Authentic Travel Journal</CardTitle>
            <ContentTitle>
              {stepFields.title}
              <span style={{ fontWeight: '600' }}>{stepFields.titleDescription} </span>
            </ContentTitle>
            <ContentBody>{stepFields.body}</ContentBody>
          </div>
          <StepButtons
            nonDisplayBack={localStep == 1}
            backStep={() => changeStep(localStep - 1)}
            nextStep={() => changeStep(localStep + 1)}
          />
        </ExplanacionConceptsBox>
      </StepContainer>
    );
  }
}

export default ExplanacionConceptsView;
